//
//
//
//
//
//
//
//
//
//
//
import ApplyNowBtn from './ApplyNowBtn';
export default {
  name: 'ApplyNow',
  components: {
    ApplyNowBtn
  }
};